function Song(method, view, artist_id, song_id) {
    this.method = method;
    this.url = '/songs/';

    if (song_id !== undefined) {
        this.url += song_id;
    }
    this.view = view;
    this.song_id = song_id;
    if (view === 'artist') {
        this.datatable = $('#artist-songs-datatable').dataTable();
    }
    this.edit_modal = $('#generic-edit-modal');
}

Song.prototype.ajax_call = function(params) {
    var self = this;
    var data;
    if (params !== undefined) data = params;
    $.ajax({
        url         : self.url,
        type        : self.method,
        dataType    : 'json',
        data        : data,
        success     : function(data) {
            if (data.notice) {
                showNotification(data.notice);
                if (self.method !== 'DELETE') self.edit_modal.modal('hide');
                if (self.datatable) {
                    self.datatable.fnDraw(false);
                } else if (self.view === 'setlist') {
                    if (data.song_id !== undefined) {
                        $('#setlist-items-table tr[data-song-id="' + data.song_id + '"] td:eq(2)').html(data.song_info);
                        $('#setlist-items-table tr[data-song-id="' + data.song_id + '"] td:eq(3)').text(data.song_length);
                    }
                    if (data.setlist_length !== undefined) {
                        $('#setlist_total_length div.input_value div.form-control').text(data.setlist_length);
                    }
                }
            } else if (data.error) {
                showNotification(data.error, 'danger');
                if (self.method !== 'DELETE') $('#submit').prop('disabled',false);
            }
        },
        error : function (request, status, error) {
            showNotification(request.responseText, 'danger', 'Error in ajax call!');
        }
    });
};

global.load_song_edit_form = function (element, event, redirect_code, header, setlist_id) {
    event.preventDefault();
    var target_url = $(element).attr('href');
    if (target_url.length) {
        $('#generic-edit-modal .modal-header h3').text(header);
        $('#generic-edit-modal').modal('show');
        $.ajax({
            url         : target_url,
            data        : {
                setlist_id : setlist_id,
                redirect_to_view : redirect_code
            },
            success     : function(data) {
                if (data.length) {
                    $('#generic-edit-modal .modal-container').html(data);
                    initDatePickerElements();
                }
            }
        });
    }
}

window.delete_song = function(params) {
    if (params.length == 2) {
        var artist_id = params[0];
        var song_id = params[1];
        var song = new Song('DELETE', 'artist', artist_id, song_id);
        song.ajax_call();
    }
}

$(document).on('submit', '.song_form', function(event) {
    event.preventDefault();
    var _this = $(this);
    var view = _this.data('view');
    var artist_id = _this.data('artist-id');
    var song_id = _this.data('id');
    var ajax_method = 'POST';
    if (song_id !== undefined) ajax_method = 'PUT';

    var song = new Song(ajax_method, view, artist_id, song_id);
    song.ajax_call(_this.serialize());
});
